require('./front_page.js');
require('./our_work.js');
require('./contact_us.js');
require('./main_menu.js');
require('./misc.js');
